/*
 * © 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/SpiderTemplate/SpiderWindowsTemplate',['lodash',
        'pixi',
        'util/eventhandler',
        'Arkadium/GameEngine/Core/EngineManagers',
        'CardUI/SupplyView',
        'CardUI/PileView',
        'CardUI/KeyboardNavigator',
        'SolitaireShared/CardLogic/Supply',
        'SolitaireShared/SpiderLogic/SpiderAuthority',
        'SolitaireShared/SpiderTemplate/SpiderInputInterpreter',
        'SolitaireShared/SpiderTemplate/SpiderCardAnimator',
        'util/SettingsManager',
        'Arkadium/GameEngine/Maths/Vector2',
        'absolute'
    ],
    function (_, PIXI, EventHandler, EngineManagers, SupplyView, PileView, KeyboardNavigator, Supply, SpiderAuthority,
        SpiderInputInterpreter, SpiderCardAnimator, SettingsManager, Vector2, Absolute) {
        "use strict";

        var SpiderWindowsTemplate = function () {
            this.initSpiderWindowsTemplate();
        };

        SpiderWindowsTemplate.prototype.initSpiderWindowsTemplate = function () {
            this._authorityReference = null;
            this._supplyViewReference = null;
            this._curAutoSolveView = null;
            this._curAutoSolveViewOnUpdated = new EventHandler();
            this.mobilePileSpacingOffset = 80;
            this.defaultPileSpacingOffset = 40;
        };

        SpiderWindowsTemplate.prototype.CreateAuthority = function (challenge) {
            var authority = challenge != null
                ? challenge.ConstructAuthority()
                : new SpiderAuthority();

            authority.Setup();
            authority.CardSupply.DeckSeed = null;

            this._authorityReference = authority;
            return authority;
        };

        SpiderWindowsTemplate.prototype.Cleanup = function () {

        };

        SpiderWindowsTemplate.prototype.CreateInputInterpreter = function (authority) {
            return new SpiderInputInterpreter(authority);
        };

        SpiderWindowsTemplate.prototype.CreateCardAnimator = function (supplyView) {
            //TODO EngineManagers.Input.MouseDown += InputManager_OnMouseDown;

            return new SpiderCardAnimator(supplyView);
        };


        SpiderWindowsTemplate.prototype.TryAutoSolve = function (supplyView) {
        };

        SpiderWindowsTemplate.prototype.StopAutoSolving = function () {
        };

        SpiderWindowsTemplate.prototype.DoLayoutPiles = function (renderManager, supplyView) {
            var isLeft = SettingsManager.getSetting('spider', 'layoutDirection') !== '1';
            var width = EngineManagers.Display.Width;
            var height = EngineManagers.Display.Height;
            var minWidth = 320;

            // reset all keyboard handlers
            _.forEach(supplyView.CardSupply.GetPileList(), function (p) {
                if (p != null) {
                    var pileView = supplyView.GetPileView(p);
                    if (pileView != null)
                        pileView.Keyboard.ResetKeypressHandlers();
                }
            }, this);


            var pile;
            var cardScale = 0.9;
            var pileScale = 1.0;
            var rowScale = 0.76;

            if (width / height < 1.5) { // portrait
                cardScale *= 0.82;
                rowScale *= 0.85;
            }

            var tabRow = 0.165 - 0.5;
            var botRow = 0.83 - 0.5;
            if (this._authorityReference.IsChallenge) {
                botRow = 0.76 - 0.5;
            }

            var mobileXOffset = 0;

            var horz_offset = .5;
            var col =
                [
                    (0.0 / 9.0 - horz_offset) * rowScale,
                    (1.0 / 9.0 - horz_offset) * rowScale,
                    (2.0 / 9.0 - horz_offset) * rowScale,
                    (3.0 / 9.0 - horz_offset) * rowScale,
                    (4.0 / 9.0 - horz_offset) * rowScale,
                    (5.0 / 9.0 - horz_offset) * rowScale,
                    (6.0 / 9.0 - horz_offset) * rowScale,
                    (7.0 / 9.0 - horz_offset) * rowScale,
                    (8.0 / 9.0 - horz_offset) * rowScale,
                    (9.0 / 9.0 - horz_offset) * rowScale
                ];


            pile = supplyView.GetPileView("Stock");
            pile.CardFacing = PileView.Facing.FaceDown;
            pile.PileMode = PileView.Layout.FanRight;

            pile.DefaultPileSpacing = new Vector2(20 / 209.0 * cardScale, 0);
            pile.FullyCompressOnDeal = true;
            pile.HeightLimit = 1;
            var thirdOfWidth = (col[3] - col[2]) / 3;

            if (Absolute.Platform.isMobile() && Absolute.ScreenMetrics.screenWidth < 1000) {
                if (!Absolute.ScreenMetrics.isPortrait()) {
                    botRow = 0.84 - 0.6;
                    if (isLeft)
                        mobileXOffset = -0.08;
                    else
                        mobileXOffset = 0.08;

                    pile.LogicalScreenPos = new Vector2(isLeft ? col[9] + thirdOfWidth * 2 : col[0] - thirdOfWidth * 2.5, tabRow);
                } else {
                    pile.LogicalScreenPos = new Vector2(isLeft ? col[7] + thirdOfWidth : col[1] + thirdOfWidth, botRow * 2);
                }
            } else
                pile.LogicalScreenPos = new Vector2(isLeft ? col[7] + thirdOfWidth : col[1] + thirdOfWidth, botRow);

            pile.InteractionMode = PileView.Interaction.Click;
            pile.FanFraction = 10;
            pile.FanLimit = 50;
            pile.DisplayType = PileView.Display.Tableau;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;

            pile.KeyboardMode = PileView.KeyboardModes.TopCard;
            // stock
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau8"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Tableau0"));

            for (var i = 0; i < 10; i++) {
                pile = supplyView.GetPileView("FaceDown" + i);
                pile.CardFacing = PileView.Facing.FaceDown;
                pile.PileMode = PileView.Layout.FanDown;

                if (Absolute.Platform.isMobile())
                    pile.DefaultPileSpacing = new Vector2(0, 40 / 209.0 * cardScale);
                else
                    pile.DefaultPileSpacing = new Vector2(0, 24 / 209.0 * cardScale);

                pile.LogicalScreenPos = new Vector2(col[i] + mobileXOffset, tabRow);
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
            }

            var stockPile = supplyView.GetPileView("Stock");
            stockPile.UpdatePosition();
            stockPile.parent.updateTransform();
            stockPile.updateTransform();
            var stockPileScreenPosition = new Vector2(stockPile.worldTransform.tx, stockPile.worldTransform.ty);
            for (var i = 0; i < 10; i++) {
                pile = supplyView.GetPileView("Tableau" + i);
                pile.CardFacing = PileView.Facing.FaceUp;
                pile.PileMode = PileView.Layout.FanDown;

                if (Absolute.Platform.isMobile())
                    pile.DefaultPileSpacing = new Vector2(0, this.mobilePileSpacingOffset / 209.0 * cardScale);
                else
                    pile.DefaultPileSpacing = new Vector2(0, this.defaultPileSpacingOffset / 209.0 * cardScale);

                pile.LogicalScreenPos = new Vector2(col[i] + mobileXOffset, tabRow);
                pile.InteractionMode = PileView.Interaction.Drag;
                //pile.DisplayType = PileView.Display.Blank;
                pile.DisplayType = PileView.Display.Tableau;
                pile.StackedPile = supplyView.GetPileView("FaceDown" + i);
                // Piles that are above the draw pile and foundation piles need more compression. the orignal calc
                // has problems in FF and IE on windows. Some race condition where the transform on the stock pile
                // isn't updated properly even after forcing it so hard coding it the correct compression (never changes anyway)
                //pile.HeightLimit = i == 0 || i == 1 || i == 8 ? (stockPileScreenPosition.y / height) - 0.08 : 0.9;

                if (Absolute.Platform.isMobile()) {
                    if (Absolute.ScreenMetrics.isPortrait())
                        pile.HeightLimit = 0.48;
                    else {
                        if (this._authorityReference.IsChallenge)
                            pile.HeightLimit = 0.75;
                        else
                            pile.HeightLimit = 0.85;
                    }
                }
                else
                    pile.HeightLimit = i == 0 || i == 1 || i == 8 ? 0.81 : 0.9;
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
                pile.KeyboardMode = PileView.KeyboardModes.AllCardsAndEmpty;
                if (i != 9)
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau" + (i + 1)));

                if (i != 0)
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau" + (i - 1)));

                if (i <= 4) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Stock"));

                } else {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Stock"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Stock"));
                }
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Stock"));
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Stock"));
            }

            supplyView.DefaultKeyboardFocus = supplyView.GetPileView("Tableau0");

            for (var i = 0; i < 8; i++) {
                pile = supplyView.GetPileView("Foundation" + i);
                pile.CardFacing = PileView.Facing.FaceUp;
                pile.PileMode = PileView.Layout.Pile;
                var column = isLeft ? col[0] : col[7];

                if (Absolute.Platform.isMobile() && Absolute.ScreenMetrics.screenWidth < 1000) {
                    if (Absolute.ScreenMetrics.isPortrait())
                        pile.LogicalScreenPos = new Vector2(column + i / 40 * cardScale, botRow * 2);
                    else
                        pile.LogicalScreenPos = new Vector2(isLeft ? col[9] + thirdOfWidth * 2 : col[0] - thirdOfWidth * 2.5, (tabRow * 0.25) * tabRow * i);
                }
                else
                    pile.LogicalScreenPos = new Vector2(column + i / 40 * cardScale, botRow);

                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
            }

            pile = supplyView.GetPileView("Root");
            pile.LogicalScreenPos = new Vector2(supplyView.GetPileView("Tableau9").LogicalScreenPos.x - 99, supplyView.GetPileView("Stock").LogicalScreenPos.y - 99);
            pile.DefaultPileSpacing = new Vector2(0, 0);
            pile.CardFacing = PileView.Facing.Hidden;
            pile.PileMode = PileView.Layout.Pile;
            pile.InteractionMode = PileView.Interaction.None;

            supplyView.CardScale = cardScale;
        };

        SpiderWindowsTemplate.prototype.LoadGameOptions = function (supply) {
            supply.SetOption("Suits", SettingsManager.getSetting('spider', 'suits'));
            
            if (SettingsManager.getSetting('spider', 'difficulty') === undefined) {
                SettingsManager.setSetting('spider', 'difficulty', "RANDOM");
            }

            supply.SetOption("Difficulty", SettingsManager.getSetting('spider', 'difficulty'));

            if (SettingsManager.getSetting('spider', 'layoutDirection') === undefined) {
                SettingsManager.setSetting('spider', 'layoutDirection', '2');
            }

        };

        SpiderWindowsTemplate.prototype.SaveGameOptions = function (supply) {
            // TODO <- i don't think we need this -@jarbot
            /*
             if (_authorityReference.IsChallenge)
             {
             return;
             }
             try
             {
             String option = supply.GetOption("Suits");
             option = option ?? "1";
             Windows.Storage.ApplicationData.Current.LocalSettings.Values[SuitsOptionKey] = option;
             }
             catch (Exception e)
             {
             Debug.WriteLine(e.Message);
             }
             */
        };

        Object.defineProperty(SpiderWindowsTemplate.prototype, "EndGameStatStrings",
            {
                get: function () {
                    return ["Time", "Score"];
                }
            });

        SpiderWindowsTemplate.prototype.GetEndGameStats = function () {
            return [
                this._authorityReference.CardSupply.CurrentTime.ToString(),
                /* String.Format("{0:n0}", */ this._authorityReference.CardSupply.Score.toString() // TODO check this
            ];
        };

        Object.defineProperty(SpiderWindowsTemplate.prototype, "SaveFilename", {
            get: function () {
                return "SPIDER_SAVE_FILE";
            }
        });

        Object.defineProperty(SpiderWindowsTemplate.prototype, "GameName", {
            get: function () {
                return "Spider";
            }
        });

        Object.defineProperty(SpiderWindowsTemplate, "SuitsOptionKey", {
            get: function () {
                return "APPDATA_KLONDIKE_SUITS";
            } // TODO is this a Arkadium bug, should it be APPDATA_SPIDER_SUITS?
        });

        return SpiderWindowsTemplate;

    });

